// Export API URL directly for easier imports
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

// You can keep the config object for other configurations
const config = {
  apiBaseUrl: API_URL,
  // Add other config values here
}

export default config 